import { ApprovalMode } from '../../../../api/agents-client/agent-client.type';

/**
 * Resolves the approval mode the composer should display and send.
 *
 * @param {ApprovalMode | null} override - The sticky composer override, or null when never toggled
 * @param {ApprovalMode | null | undefined} savedDefault - The user's saved Customize Flora default
 * @returns {ApprovalMode} The override when set, else the saved default, else Ask
 */
function resolveApprovalMode(
  override: ApprovalMode | null,
  savedDefault: ApprovalMode | null | undefined,
): ApprovalMode {
  return override ?? savedDefault ?? ApprovalMode.Ask;
}

/**
 * Text color for the toggle; Auto is highlighted so an active auto mode is obvious.
 *
 * @param {ApprovalMode} mode - The displayed approval mode
 * @returns {string} A CSS color value
 */
function getApprovalModeColor(mode: ApprovalMode): string {
  return mode === ApprovalMode.Auto ? 'var(--secondary-base)' : 'var(--ink-lighter)';
}

/**
 * Background for the toggle; Auto gets a tinted pill, Ask stays transparent like the other toolbar buttons.
 *
 * @param {ApprovalMode} mode - The displayed approval mode
 * @returns {string} A CSS background value
 */
function getApprovalModeBackground(mode: ApprovalMode): string {
  return mode === ApprovalMode.Auto ? 'var(--secondary-lightest)' : 'transparent';
}

/**
 * Visibility for a menu item's check mark; hidden (not removed) so labels stay aligned.
 *
 * @param {boolean} visible - Whether the item is the current mode
 * @returns {string} A CSS visibility value
 */
function getCheckVisibility(visible: boolean): string {
  return visible ? 'visible' : 'hidden';
}

export { getApprovalModeBackground, getApprovalModeColor, getCheckVisibility, resolveApprovalMode };
